export default "__VITE_ASSET__BCOL03$z__"